import { EventEmitter } from "events";
class MockController extends EventEmitter {
    homeId = 1;
    nodes = new Map();
}
class MockDriver extends EventEmitter {
    controller = new MockController();
    ready = true;
    allNodesReady = true;
    configVersion = "0.0.0-mock";
    statisticsEnabled = true;
    async start() {
        this.emit("driver ready");
    }
    getLogConfig() {
        return {
            enabled: true,
            level: "debug",
            transports: [],
        };
    }
    updateLogConfig(_config) { }
    updateUserAgent(_additionalUserAgentComponents) { }
    updateOptions(_options) { }
    async destroy() { }
}
export const createMockDriver = () => new MockDriver();
